import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button, Icon, InfoCard } from 'ui';
import { withRouter } from 'utils/withRouter';
import usePermissionCheck from '../../../utils/hooks/usePermissionCheck';
import FollowUpCardContent from './follow-up-card-content';
import SmartActionCardContent from './smart-action-card-content';

const TrashIcon = styled(Icon)`
  font-size: 20px;
  cursor: pointer;
`;

const CardButton = styled(Button)`
  background-color: ${p => p.theme.colors[p.isPrimary ? 'theme' : 'themeSecondary']} !important;
  text-transform: uppercase;
  min-width: 220px;
  width: auto;
`;

const SmartActionCard = ({
  action,
  openSidepanel,
  deleteSmartAction,
  intl,
  followUpTypes = [],
  isFollowUp = false,
  history,
}) => {
  const [checkPermission] = usePermissionCheck();
  const canEdit = checkPermission('ordercreate');
  const isRequested = !action.status;
  const renderButtons = () => {
    if (isFollowUp) {
      return (
        <Button
          onClick={openSidepanel}
          type='secondary'
          isPrimary={false}
        >
          {intl.formatMessage({ id: 'common.EDIT' })}
        </Button>
      );
    }
    if (isRequested) {
      return (
        <CardButton
          onClick={openSidepanel}
          type='secondary'
          isPrimary={canEdit}
          data-test-id='btn-show-smart-info-or-link-smart-order'
        >
          {canEdit ?
            intl.formatMessage({ id: 'ticket.smart_actions.SHOW_EDIT_LINK' }) :
            intl.formatMessage({ id: 'ticket.smart_actions.EDIT_SMART_INFO' })
          }
        </CardButton>
      );
    }
    return (
      <>
        <CardButton
          onClick={openSidepanel}
          type='secondary'
          isPrimary={false}
          data-test-id='btn-shown-smart-info'
        >
          {intl.formatMessage({ id: 'ticket.smart_actions.SHOW_SMART_INFO' })}
        </CardButton>
        {action?.order && <CardButton
          disabled={!action?.order?.objectId}
          onClick={() =>
            action?.order?.objectId &&
            history.push(`/order/${action?.order?.objectId}`, { context: action?.order?.objectId })
          }
          type='secondary'
          isPrimary={true}
          data-test-id='btn-open-smart-order'
        >
          {intl.formatMessage({ id: 'ticket.smart_actions.OPEN_SMART_ORDER' })}
        </CardButton>}
      </>
    );
  };

  return (
    <InfoCard
      cardIconType='magic'
      cardIconColor='#9013FE'
      title={action?.actionType?.description}
      headerActionComponent={isRequested ? <TrashIcon
        type='trash-alt'
        light={true}
        onClick={() => deleteSmartAction(action)}
      /> :
        null}
      renderFooter={renderButtons}
      footerActionCount={isRequested ? 1 : 2}
    >
      {isFollowUp ?
        <FollowUpCardContent action={action} followUpTypes={followUpTypes} /> :
        <SmartActionCardContent
          action={action}
          isRequested={isRequested}
          isWriteUser={canEdit}
        />
      }
    </InfoCard>
  );
};
SmartActionCard.propTypes = {
  action: PropTypes.string,
  openSidepanel: PropTypes.func,
  deleteSmartAction: PropTypes.func,
  intl: PropTypes.object,
  followUpTypes: PropTypes.array,
  isFollowUp: PropTypes.bool,
  history: PropTypes.object,
};

export default injectIntl(withRouter(SmartActionCard));
